package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.input.InputText
import com.wintermar.inspection.core.ui.component.input.util.InputState
import com.wintermar.inspection.core.ui.component.input.util.InputStateModel
import kotlinx.coroutines.FlowPreview
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.debounce
import kotlin.time.Duration.Companion.milliseconds

@OptIn(FlowPreview::class)
@Composable
fun InputFreeText(
    answer: String,
    onValueChanged: (String) -> Unit
) {
    val scope = rememberCoroutineScope()
    val inputState = remember {
        InputState(
            initialData = InputStateModel(
                value = answer,
                placeholder = "Your response"
            ),
            scope
        )
    }

    LaunchedEffect(inputState) {
        snapshotFlow { inputState.value.text }
            .debounce(1200.milliseconds)
            .collectLatest { char ->
                onValueChanged(char.toString())
            }
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
    ) {
        InputText(
            state = inputState,
            modifier = Modifier.fillMaxWidth()
        )
    }
}
